import { doc, getDoc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import { firestore } from '../firebase';

export const DEFAULT_BRANDING = {
  productName: 'Pravah',
  tagline: 'Your Practice. In Flow. With Pravah.',
  organisationName: 'D.C. Shukla & Co.',
  organisationTagline: '',
  organisationLogoPath: '/brand/organisation-logo.png',
  showOrganisationLogo: true,
  loginHeading: 'Welcome back',
  loginSubheading: 'Sign in to continue to your workspace.',
  supportEmail: '',
  accentColor: '#C8A96B',
};

const brandingRef = doc(firestore, 'appSettings', 'branding');

export function subscribeBranding(onData, onError) {
  return onSnapshot(
    brandingRef,
    (snapshot) => onData({ ...DEFAULT_BRANDING, ...(snapshot.exists() ? snapshot.data() : {}) }),
    onError
  );
}

export async function getBrandingOnce() {
  const snapshot = await getDoc(brandingRef);
  return { ...DEFAULT_BRANDING, ...(snapshot.exists() ? snapshot.data() : {}) };
}

export async function saveBranding(values, userId) {
  const safeValues = {
    productName: 'Pravah',
    tagline: DEFAULT_BRANDING.tagline,
    organisationName: String(values.organisationName || '').trim(),
    organisationTagline: String(values.organisationTagline || '').trim(),
    organisationLogoPath: '/brand/organisation-logo.png',
    showOrganisationLogo: values.showOrganisationLogo !== false,
    loginHeading: String(values.loginHeading || '').trim(),
    loginSubheading: String(values.loginSubheading || '').trim(),
    supportEmail: String(values.supportEmail || '').trim(),
    accentColor: DEFAULT_BRANDING.accentColor,
  };

  await setDoc(
    brandingRef,
    {
      ...DEFAULT_BRANDING,
      ...safeValues,
      updatedAt: serverTimestamp(),
      updatedById: userId || '',
    },
    { merge: true }
  );
}
